import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ProductCreateObservationsPage } from '../../product-create/product-create-observations/product-create-observations';

/**
 * Generated class for the DishViewPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-product-view-observations',
    templateUrl: 'product-view-observations.html',
})
export class ProductViewObservationsPage {
    @Input() product: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {

    }

    edit() {
        this.navCtrl.push(ProductCreateObservationsPage, {
            product_uid: this.product.UID,
            product_name: this.product.name,
            observations: this.product.observations,
            product: this.product,
        })
    }


}



// WEBPACK FOOTER //
// ./src/pages/products/product-view/product-view-observations/product-view-observations.ts